import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
import { useLabels } from '@telia-front/label-provider';
const ComparisonImage = (props) => {
    const labels = useLabels();
    const { onRemoveButtonClick, image, button, removeButtonLabel, isDisabled } = props;
    return (React.createElement("div", { className: "product-comparison__item-image-container" },
        React.createElement(Anchor, Object.assign({}, button, { tabIndex: isDisabled ? -1 : undefined }),
            React.createElement(Image, Object.assign({}, image, { className: "product-comparison__item-image", width: 180 }))),
        onRemoveButtonClick && (React.createElement("button", { className: "product-comparison__remove-btn", onClick: onRemoveButtonClick, type: "button", disabled: isDisabled },
            React.createElement(Icon, { modifiers: "#close-round", className: "product-comparison__remove-btn-icon" }),
            React.createElement("span", { className: "sr-only" }, removeButtonLabel || labels.get('remove'))))));
};
export default ComparisonImage;
